const NO_IMAGE_AVAL_SRC =
  'https://vignette.wikia.nocookie.net/citrus/images/6/60/No_Image_Available.png'

const REGEX_NUMBER_ONLY = /^[0-9]*$/

const BOT_GENDER_SETTING_LABEL = {
  TITLE: 'ตั้งค่าเพศของบอท',
  BOT_GENDER: 'เพศ',
  SAVE: 'SAVE',
  SELECT_BOT_GENDER_ERROR: 'กรุณาเลือกเพศของบอท',
  SAVE_SUCCESS: 'บันทึกข้อมูลเพศของบอทเรียบร้อยแล้ว',
  BOT_GENDER_LABEL: {
    MALE: 'ชาย',
    FEMALE: 'หญิง',
  },
  BOT_GENDER_TYPE: {
    MALE: 'MALE',
    FEMALE: 'FEMALE',
  },
}

const PRODUCT_DISPLAY_SETTING_LABEL = {
  TITLE: 'ตั้งค่าการแสดงสินค้า',
  SEARCH_ORDER: 'ลำดับการแสดงสินค้า',
  SAVE: 'SAVE',
  SELECT_SEARCH_ORDER__ERROR: 'กรุณาเลือกลำดับการแสดงสินค้า',
  SAVE_SUCCESS: 'บันทึกข้อมูลการตั้งค่าการแสดงสินค้าเรียบร้อยแล้ว',
  SEARCH_ORDER_LABEL: {
    LAST_CREATED: 'ใหม่',
    FIRST_CREATED: 'เก่า',
  },
  SEARCH_ORDER_TYPE: {
    LAST_CREATED: 'LAST_CREATED',
    FIRST_CREATED: 'FIRST_CREATED',
  },
}

const ORDER_STATE = {
  ORDER_PLACED: 'ORDER_PLACED',
  WAIT_FOR_PAYMENT_APPROVE: 'WAIT_FOR_PAYMENT_APPROVE',
  PREPARE_TO_SHIPPING: 'PREPARE_TO_SHIPPING',
  SHIPPED: 'SHIPPED',
  ABANDONED: 'ABANDONED',
  CANCELLED: 'CANCELLED',
}

const EXPORT_ORDER_LABEL = {
  TITLE: 'Export Orders',
  PICKER_START_DATE: 'Start Date',
  PICKER_END_DATE: 'End Date',
  SELECT_ORDER_STATE: 'Order state',
  EXPORT_BUTTON: 'Export',
  ERROR_ORDER_NOT_FOUND: 'Order does not exist in that state and date',
}

const ORDER_HEADER_LABEL = {
  TITLE: 'Orders',
  MENU: 'menu',
  SEARCH_BAR: 'search',
  EXPORT_ORDER_BUTTON: 'Export Orders',
}

const PAYMENT_SETTING = {
  ACCOUNT: {
    TYPE: {
      LABEL: {
        SAVING: 'ออมทรัพย์',
        CURRENT: 'กระแสรายวัน',
      },
      VALUE: {
        SAVING: 'SAVING',
        CURRENT: 'CURRENT',
      },
    },
  },
  BANK: {
    NAME: {
      TH: {
        BAY: 'กรุงศรีอยุธยา',
        BBL: 'กรุงเทพ',
        CIMB: 'ซีไอเอ็มบี',
        CITI: 'ซิตี้',
        GSB: 'ออมสิน',
        KBANK: 'กสิกรไทย',
        KTB: 'กรุงไทย',
        SCB: 'ไทยพาณิชย์',
        TMB: 'ทหารไทย',
        TTB: 'ทีเอ็มบีธนชาต',
        UOB: 'ยูโอบี',
      },
    },
    ICON: {
      BBL: 'https://storage.googleapis.com/deeple-sme/bank-icon/bbl.png',
      CIMB: 'https://storage.googleapis.com/deeple-sme/bank-icon/cimb.png',
      CITI: 'https://storage.googleapis.com/deeple-sme/bank-icon/citi.png',
      GSB: 'https://storage.googleapis.com/deeple-sme/bank-icon/gsb.png',
      KBANK: 'https://storage.googleapis.com/deeple-sme/bank-icon/kbank.png',
      KTB: 'https://storage.googleapis.com/deeple-sme/bank-icon/ktb.png',
      PROMPTPAY:
        'https://storage.googleapis.com/deeple-sme/bank-icon/prompt-pay.png',
      SCB: 'https://storage.googleapis.com/deeple-sme/bank-icon/scb.png',
      TMB: 'https://storage.googleapis.com/deeple-sme/bank-icon/tmb.png',
      UOB: 'https://storage.googleapis.com/deeple-sme/bank-icon/uob.png',
      BAY: 'https://storage.googleapis.com/deeple-sme/bank-icon/krungsri.png',
      TTB: 'https://storage.googleapis.com/deeple-sme/bank-icon/ttb.png',
    },
  },
}

export {
  BOT_GENDER_SETTING_LABEL,
  EXPORT_ORDER_LABEL,
  NO_IMAGE_AVAL_SRC,
  ORDER_HEADER_LABEL,
  ORDER_STATE,
  PRODUCT_DISPLAY_SETTING_LABEL,
  REGEX_NUMBER_ONLY,
  PAYMENT_SETTING,
}



// WEBPACK FOOTER //
// ./src/constant.js